export default {"src":"/_next/static/media/moveUp.85527829.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};